import { useState, useEffect } from 'react'
import api from '@api'
import { IIntegrations, IIntegration, IEnableField } from '@api/integration/types'
import track from '@track'
import Event from '@track/Event'
import { useReload } from '@hooks/reloadContext'

export default function useIntegrations() {
  const [state, setState] = useState<IIntegrations>({
    loading: true,
    active: [],
    available: [],
  })
  const reload = useReload()

  useEffect(() => {
    api.integration.list().then((integrations) => {
      setState({ ...integrations, loading: false })
    })
  }, [])

  return {
    ...state,
    regenerateToken: (id: string) => {
      track.integration({ eventName: Event.TOKEN_REGENERATE })
      return api.integration.regenerate({ id })
    },
    disableIntegration: (id: string) => {
      track.integration({ eventName: Event.DELETE_RECORD_DIALOG })
      return api.integration.disable({ id }).then((deletedIntegration) => {
        if (state) {
          setState({
            ...state,
            active: state.active.reduce(
              (updatedActiveIntegration: IIntegration[], integration: IIntegration) => {
                if (integration.id !== deletedIntegration.id) {
                  updatedActiveIntegration.push(integration)
                }
                return updatedActiveIntegration
              },
              []
            ),
          })
        }
        reload.appData()
        return deletedIntegration
      })
    },
    enableIntegration: (source: string, id: string, fields: IEnableField[]) => {
      return api.integration.enable({ source, fields }).then((enabledIntegration: IIntegration) => {
        return api.integration.getNode(id).then((updatedDefinition) => {
          if (state) {
            setState({
              ...state,
              active: [...state.active, enabledIntegration],
              available: state.available.map((integraion) =>
                integraion.id === id ? updatedDefinition : integraion
              ),
            })
          }
          reload.appData()
          return enabledIntegration
        })
      })
    },
    updateIntegration: (id: string, source: string, fields: IEnableField[]) => {
      return api.integration
        .update({ id, source, fields })
        .then((updatedIntegration: IIntegration) => {
          if (state) {
            setState({
              ...state,
              active: state.active.map((integraion) =>
                integraion.id === updatedIntegration.id ? updatedIntegration : integraion
              ),
            })
          }
          return updatedIntegration
        })
    },
    sendSlackInstructions: (integrationId: string) => {
      return api.integration.sendSlackInstructions({ integrationId })
    },
  }
}
